"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../utils/index.js");
var _templates = _interopRequireDefault(require("./templates"));
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getTemplate = function getTemplate(eventType) {
  var _templates$eventType;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultTemplate = (0, _defaultTemplate["default"])(values);
  var template = (_templates$eventType = _templates["default"][eventType]) === null || _templates$eventType === void 0 ? void 0 : _templates$eventType.call(_templates["default"], values);
  return template ? (0, _index.mergeObjects)(template, defaultTemplate) : undefined;
};
var _default = exports["default"] = getTemplate;